import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { TranslateService } from '@ngx-translate/core';
import { DswToastService } from '@vi-succ/design-system-web';
import { ShoppingCartFacade } from '@vi-succ/shoppingcart-domain';
import { of, tap } from 'rxjs';
import { catchError, concatMap, map } from 'rxjs/operators';
import { EtCatalogDataService } from '../../../services/et-catalog-data.service';
import { AuthService } from '../services/auth.service';
import * as loginActions from './login.actions';

@Injectable()
export class LoginEffects {
  loadUser$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loginActions.loadUserRequest),
      concatMap(() =>
        this.authService.fetchUserData().pipe(
          tap((contextInfo) => {
            this.catalogService.validateUserCatalogs(contextInfo).then((catalog) => {
              if (catalog) {
                this.cartFacade.resetCart();
                const toastMessage = this.translateService.instant('shopping_cart.warning.catalog_switched');
                this.toastService.open(toastMessage, 'warning', {
                  closeButton: true,
                  disableTimeOut: true,
                });
              }
            });
          }),
          map((contextInfo) => loginActions.loadUserSuccess(contextInfo)),
          catchError((err) => {
            return of(loginActions.loadUserFail(err));
          }),
        ),
      ),
    ),
  );

  constructor(
    private actions$: Actions,
    private authService: AuthService,
    private catalogService: EtCatalogDataService,
    private cartFacade: ShoppingCartFacade,
    private toastService: DswToastService,
    private translateService: TranslateService,
  ) {}
}
